import React, { Dispatch, SetStateAction } from "react";

export const GlobalVariableContext = React.createContext<{
  loginSuccessUrl: string;
  setLoginSuccessUrl: Dispatch<SetStateAction<string>>;
  testResultUrl: string;
  setTestResultUrl: Dispatch<SetStateAction<string>>;
} | null>(null);
